import { render } from "./dynamic-message-collection.vue?vue&type=template&id=1ad4e5d0"
import script from "./dynamic-message-collection.vue?vue&type=script&lang=js"
export * from "./dynamic-message-collection.vue?vue&type=script&lang=js"

import "./dynamic-message-collection.vue?vue&type=style&index=0&id=1ad4e5d0&lang=css"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__